{
  "pastInvoices": "Past Invoices",
  "year": "Year:",
  "missingInvoices": "If an invoice is missing or you need access to older invoices, please ",
  "contactSupport": "contact support",
  "period": "Period",
  "amount": "Amount",
  "details": "Details",
  "download": "Download",
  "invoiceError": "An error occurred while loading your invoice, please try again later.",
  "printInvoice": "Print Invoice",
  "enterprisePlanCallout": "For any questions about invoices, please contact your Customer Success Manager directly, or  <a href='mailto:csm@$t(common:defaultHost)'>CSM@$t(common:defaultHost)</a>."
}
